module.exports = __webpack_public_path__ + "image/chat_bot.fd9d06b3.jpg";